import type { SVGAttributes } from "react";

export default function WishListIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.26667 2.14786C8.41166 1.78275 11.5883 1.78275 14.7333 2.14786C15.9808 2.29286 16.875 3.36452 16.875 4.58952V17.5004C16.8749 17.6068 16.8475 17.7114 16.7956 17.8043C16.7437 17.8972 16.6689 17.9754 16.5784 18.0313C16.4878 18.0872 16.3845 18.1191 16.2782 18.1239C16.1718 18.1287 16.0661 18.1062 15.9708 18.0587L10 15.0745L4.02917 18.0604C3.93382 18.108 3.82788 18.1304 3.72142 18.1255C3.61496 18.1206 3.51151 18.0886 3.42091 18.0325C3.33031 17.9764 3.25556 17.898 3.20377 17.8049C3.15198 17.7118 3.12486 17.6069 3.125 17.5004V4.58952C3.125 3.36452 4.01917 2.29286 5.26667 2.14786Z"
        fill="currentColor"
      />
    </svg>
  );
}
